function checkForYotpoContainer() {
  const setMinimumReviews = window.theme.yotpoMinReviewCount ? window.theme.yotpoMinReviewCount : 0

  if (document.body.classList.contains('template--product')) {
    const wrapper = document.getElementById('yotpo-reviews-main-widget')

    if (!wrapper) return

    const reviewsContainer = document.getElementById('yotpo-reviews-container')
    const reviewsEmptyState = document.querySelector('.yotpo-main-layout.yotpo-main-reviews-widget .yotpo-empty-state')

    if (!reviewsContainer && !reviewsEmptyState) return

    const reviewsCountOnFirstPage = reviewsContainer?.querySelector('.yotpo-reviews-list-wrapper')?.children.length || 0

    if (wrapper.contains(reviewsContainer) && reviewsCountOnFirstPage >= setMinimumReviews) {
      wrapper.style.display = 'block'
    } else {
      wrapper.style.display = 'none';
      const starRatingsWidget = document.querySelector('.info-content-row .yotpo-widget-instance')
      if (starRatingsWidget) {
        starRatingsWidget.parentElement.style.display = 'none'
      }
    }

    yotpoObserver.disconnect();

  } else if (document.body.classList.contains('template--collection') || document.body.classList.contains('template--search')) {
    const wrappers = document.querySelectorAll('yotpo-reviews-stars:not([data-yotpo-checked])')

    if (wrappers.length === 0) return

    wrappers.forEach(wrapper => {
      const reviewCountWrapper = wrapper.querySelector('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel')

      if (!reviewCountWrapper) return

      const reviewCount = parseInt(reviewCountWrapper.textContent.trim())

      if (reviewCount >= setMinimumReviews) {
        wrapper.style.display = 'block'
      }

      wrapper.setAttribute('data-yotpo-checked', 'true')
    })

    if (document.querySelectorAll('yotpo-reviews-stars:not([data-yotpo-checked])').length === 0) {
      yotpoObserver.disconnect();
    }

  } else {
    yotpoObserver.disconnect();
    return
  }
}

const yotpoObserver = new MutationObserver(() => checkForYotpoContainer());

let yotpoDisconnectTimeout

function observeYotpoContainer() {
  yotpoObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  clearTimeout(yotpoDisconnectTimeout)
  yotpoDisconnectTimeout = setTimeout(() => yotpoObserver.disconnect(), 20000);
}

observeYotpoContainer()

document.addEventListener('click', e => {
  if (e.target.closest('[data-load-more-el="load-more-trigger"], [data-load-more-el="load-previous-trigger"], [data-load-more-trigger], [data-load-previous-trigger], .custom-filter-load-more, .klevuPaginate')) {
    observeYotpoContainer()
  }
});
